import { entityGenerator } from '@/lib/entityGenerator'

interface CapitalizeOptions {
	forceCaseOnAllChars: boolean
	capitalization: Capitalization
	limit: number
}

// eslint-disable-next-line no-restricted-syntax
enum Capitalization {
	Letters = 'letters',
	Words = 'words',
	Sentences = 'sentences',
}

const getCapitalizeOptions = entityGenerator<CapitalizeOptions>({
	forceCaseOnAllChars: false,
	capitalization: Capitalization.Words,
	limit: 0,
})

export function capitalize(str: string, options: Partial<CapitalizeOptions> = {}) {
	const config = getCapitalizeOptions(options)
	const sep =
		config.capitalization === Capitalization.Words
			? /\s+/g
			: config.capitalization === Capitalization.Sentences
				? /\\n+|\.+\s?/g
				: ''
	const join =
		config.capitalization === Capitalization.Words
			? ' '
			: config.capitalization === Capitalization.Sentences
				? '. '
				: ''
	const _str = String(str ?? '')
	let final = _str
		.split(sep)
		.filter(Boolean)
		.map((s, i) => {
			const sTrimmed = s.trim()
			if ((config.limit && i >= config.limit) || !sTrimmed.length) {
				return sTrimmed
			}
			if (config.forceCaseOnAllChars) {
				return sTrimmed[0].toLocaleUpperCase() + sTrimmed.slice(1).toLocaleLowerCase()
			}
			return sTrimmed[0].toLocaleUpperCase() + sTrimmed.slice(1)
		})
		.join(join)
	if (_str.trim().endsWith('.')) {
		final += '.'
	}
	return final
}
